export default __webpack_public_path__ + "static/media/receipt.b3ebf560.ttf";